export default __webpack_public_path__ + "static/media/03-SapphireDonut.6f897841.png";